import React from "react";
import { useSelector } from "react-redux";
import { generateJoyRideSteps } from "../components/GenerateJoyRideStep";

const useJoyRide = () => {
    const [isJoyRideRunning, setIsoyRideRunning] = React.useState(false);
    const [joyRideSteps, setJoyRideSteps] = React.useState([]);

    const type = useSelector((state) => state?.type?.type);
    const conversation = useSelector((state) => state.conversation.conversations);
    const conversationId = useSelector((state) => state.conversation.conversation_id);
    const userFormats = useSelector((state) => state.type.userFormats);
    const prompts = useSelector((state) => state.type.prompts);
    const files = useSelector((state) => state.type.list_of_files);
    const shared_files = useSelector((state) => state.type.shared_files);

    const startJoyRide = React.useCallback(() => {
        setIsoyRideRunning(true);
    }, []);

    React.useEffect(() => {
        const steps = generateJoyRideSteps(
            conversation,
            conversationId,
            type,
            userFormats,
            prompts,
            files,
            shared_files
        );
        setJoyRideSteps(steps);
    }, [conversation, conversationId, type, prompts, userFormats, files, shared_files]);

    return { isJoyRideRunning, joyRideSteps, startJoyRide, setIsoyRideRunning };
};

export default useJoyRide;